export default "__VITE_ASSET__010f1cdc__"